// Normalize any Vimeo URL to a proper background-player embed URL with required params.
// Accepts:
//   - https://vimeo.com/828239088
//   - https://vimeo.com/828239088/abc123 (with unlisted hash)
//   - https://player.vimeo.com/video/828239088
//   - https://player.vimeo.com/video/828239088?h=xxx&foo=bar
// Returns a URL that autoplays silently in the background with playsinline for mobile.
// If the URL is not a Vimeo URL it is returned untouched (user risk for YouTube etc.).
export function normalizeVimeoEmbed(url, { background = true, muted = true } = {}) {
  if (!url || typeof url !== "string") return "";

  const vimeoMatch = url.match(
    /(?:vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?|player\.vimeo\.com\/video\/)(\d+)(?:\/([a-zA-Z0-9]+))?/
  );

  if (!vimeoMatch) return url; // not a Vimeo URL — pass through

  const id = vimeoMatch[1];
  const hashFromPath = vimeoMatch[2];

  // preserve ?h= hash if present in query
  let hashFromQuery;
  try {
    const q = new URL(url).searchParams.get("h");
    if (q) hashFromQuery = q;
  } catch {}

  const h = hashFromPath || hashFromQuery;

  const params = new URLSearchParams({
    background: background ? "1" : "0",
    autoplay: "1",
    loop: "1",
    muted: muted ? "1" : "0",
    autopause: "0",
    playsinline: "1",
    byline: "0",
    title: "0",
    portrait: "0",
    controls: "0",
    dnt: "1",
  });
  if (h) params.set("h", h);

  return `https://player.vimeo.com/video/${id}?${params.toString()}`;
}

export function isVimeoUrl(url) {
  if (!url) return false;
  return /(?:vimeo\.com|player\.vimeo\.com)/.test(url);
}
